import { unwrap } from '@/api/envelope';
import { useGetModerationHistoryByContent } from '@/api/generated/moderation/moderation';
import type { AdminModerationHistoryResponseDTO } from '@/api/generated/model';
import { ModerationHistoryList } from '@/components/ModerationHistoryList';
import { pickHistoryRiskIndicators } from '@/features/moderation/lib/combinedRiskDisplay';
import { useContentIntelligence } from '../api';

// Content moderation history (op #5, contentType=P). Enveloped (shape A) -> unwrap to the row array.
// Policy max + 12 Policy confidences (legacy safety fallback) from content-intelligence cache.
export function ModerationHistoryCard({ contentId }: { contentId: string }) {
  const id = Number(contentId);
  const valid = Number.isFinite(id) && id > 0;
  const query = useGetModerationHistoryByContent(
    id,
    { contentType: 'P' },
    {
      query: {
        enabled: valid,
        select: (res) => unwrap<AdminModerationHistoryResponseDTO[] | undefined>(res) ?? [],
      },
    },
  );
  const { data: intelligence } = useContentIntelligence(contentId);
  const riskIndicators = pickHistoryRiskIndicators(intelligence);

  return (
    <ModerationHistoryList
      entries={query.data ?? []}
      isLoading={query.isLoading}
      isError={query.isError}
      onRetry={() => void query.refetch()}
      hideSubject
      riskIndicators={riskIndicators}
    />
  );
}
